import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConfig } from "../config/app.config";
import { CacheMessageResponse } from "../models/cache-message.model";

/** Clears logdetails, temp, indication, quote, and policy cache for one session. */
export const SESSION_CACHE_CLEAR_TYPE = "session";

@Injectable({
  providedIn: "root",
})
export class SessionCacheApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = AppConfig.apiUrl;

  set<T>(
    type: string,
    sessionId: string | number,
    payload: T
  ): Observable<CacheMessageResponse> {
    const path = `/api/cache/set?type=${type}&sessionId=${encodeURIComponent(String(sessionId))}`;
    return this.http.post<CacheMessageResponse>(this.proxyUrl(path), payload);
  }

  get<T>(type: string, sessionId: string | number): Observable<T> {
    const path = `/api/cache/get?type=${type}&sessionId=${encodeURIComponent(String(sessionId))}`;
    return this.http.get<T>(this.proxyUrl(path));
  }

  remove(
    type: string,
    sessionId: string | number
  ): Observable<CacheMessageResponse> {
    const path = `/api/cache/remove?type=${type}&sessionId=${encodeURIComponent(String(sessionId))}`;
    return this.http.delete<CacheMessageResponse>(this.proxyUrl(path));
  }

  /** DELETE api/cache/remove?type=session — all workflow + login cache sections. */
  removeSession(sessionId: string | number): Observable<CacheMessageResponse> {
    return this.remove(SESSION_CACHE_CLEAR_TYPE, sessionId);
  }

  private proxyUrl(path: string): string {
    const encodedPath = encodeURIComponent(path);
    return `${this.apiUrl}/Proxy?path=${encodedPath}`;
  }
}
